import Box from '@zenbusiness/zui/Box';
import Grid from '@zenbusiness/zui/Grid';
import List from '@zenbusiness/zui/List';
import { superstyled } from '@zenbusiness/zui/styles';

export const Branding = superstyled({
  tag: Box,
  name: 'BusinessEntityNav',
  slot: 'Branding',
  styles: ({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '5.75rem',
      lineHeight: '1',
      paddingInline: '1.5rem',
    },
  }),
});

export const Menu = superstyled({
  tag: List,
  name: 'BusinessEntityNav',
  slot: 'Menu',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    '& > li': {
      alignItems: 'inherit',
      flexDirection: 'column',
      paddingInlineStart: '0.5rem',
      paddingInlineEnd: '1rem',
      gap: 'unset',
    },

    '& li li': {
      '& a': {
        paddingBlock: '0.75rem',
      },
    },

    [theme.breakpoints.up('md')]: {
      '& > li': {
        paddingInline: '1.375rem',
      },
    },
  }),
});

export const Nav = superstyled({
  tag: Grid,
  name: 'BusinessEntityNav',
  slot: 'Nav',
  styles: ({ theme }) => ({
    '--nav-width': '5.75rem',
    '--nav-width-wide': '17.5rem',

    background: theme.palette.common.black,
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    height: '100vh',
    overflowX: 'hidden',
    position: 'sticky',
    top: '0',
    width: 'var(--nav-width-wide)',
    zIndex: theme.zIndex.drawer,
  }),
});
